export default __webpack_public_path__ + "static/media/9.f0c3394e.jpg";